import React from 'react';
import { DatePicker as AntdDatePicker } from 'antd';
import dayjs, { Dayjs } from 'dayjs';

interface Props {
  value?: string;
  onChange?: (date: string) => void;
}

const DatePicker = ({ value, onChange }: Props) => {
  return (
    <AntdDatePicker<Dayjs>
      format="DD.MM.YYYY"
      value={value ? dayjs(value) : null}
      onChange={(date) => {
        if (onChange) onChange(date.toISOString());
      }}
    />
  );
};

export default DatePicker;
